module.exports = __webpack_public_path__ + "img/71.2.TN.04057ac5.png";